<template>
  <NuxtImg
    :src="iconUrl"
    alt=""
    width="32"
    height="32"
    :style="{
      '--scale': props.scale,
    }"
    :class="cn('internal-icon w-[1em] h-[1em] shrink-0', props.class)"
    :draggable="false"
  />
</template>

<script setup lang="ts">
import Icons, { type IconLabel } from "~/icons-mapper/icons";

interface IconProps {
  name: IconLabel;
  scale?: number;
  class?: string;
}
const props = withDefaults(defineProps<IconProps>(), {
  scale: 1,
});

const icon = computed(() => Icons.find((x) => x.label === props.name));
const iconUrl = computed(() => `/icons/${icon.value?.src}`);
</script>

<style scoped>
.internal-icon {
  font-size: calc(var(--scale, 1) * 1em);
}
</style>
